import { downloadFromApiResponse } from "@/utils/downloadUtils";
import { goSolidApi } from "@/composables/useGoSolidApi";
import type {
  AiConversationDetail,
  AiConversationPage,
  AiUploadView,
  ConversationQuery,
} from "./aiConversationsTypes";

/** Lists the paged admin audit index. Errors propagate to the caller's global handler. */
export async function listConversations(
  query: ConversationQuery,
  signal?: AbortSignal
): Promise<AiConversationPage> {
  const params = {
    ...query,
    conversation_types: query.conversation_types?.join(","),
  };
  return (
    await goSolidApi.get("/api/admin/ai-assistant/conversations", {
      params,
      signal,
    })
  ).data;
}
/** Loads the complete persisted trace for one conversation. */
export async function getConversation(
  id: number,
  signal?: AbortSignal
): Promise<AiConversationDetail> {
  return (
    await goSolidApi.get(`/api/admin/ai-assistant/conversations/${id}`, {
      signal,
    })
  ).data;
}
/** Downloads through the authenticated API client, never by exposing a bearer token in a URL. */
export async function downloadUpload(upload: AiUploadView): Promise<void> {
  const response = await goSolidApi.get(upload.download_url, {
    responseType: "blob",
  });
  downloadFromApiResponse(response.data, response.headers, upload.display_name);
}
